import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListInvoices extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/invoices/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'External Invoice Number',
        dataIndex: 'invoice_number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Status Date',
        dataIndex: 'updated_date'
      }
    ]
  }

  getData = () => {
    const { invoices } = this.props

    const data = invoices.map((invoice, index) => {
      // format date from db
      invoice.updated_date = moment(new Date(invoice.updated_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${invoice.id}${index}`,
          job: {
            job_id: invoice.job_id,
            job_type: invoice.job_type,
            id: invoice.id
          }
        },
        invoice
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Invoices</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListInvoices



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListInvoices.js